export default "__VITE_ASSET__BZTMHgCm__"